export const STARDOG_DATA_SOURCE_PREFIX = 'data-source://';

export const RDF_IRI = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#';
export const RDF_TYPE_IRI = `${RDF_IRI}type`;
export const RDF_PROPERTY = `${RDF_IRI}Property`;

export const OWL_IRI = 'http://www.w3.org/2002/07/owl#';
export const OWL_DATATYPE_PROPERTY_IRI = `${OWL_IRI}DatatypeProperty`;
export const OWL_OBJECT_PROPERTY_IRI = `${OWL_IRI}ObjectProperty`;
export const OWL_THING_IRI = `${OWL_IRI}Thing`;

export const RDFS_IRI = 'http://www.w3.org/2000/01/rdf-schema#';
export const RDFS_DOMAIN_IRI = `${RDFS_IRI}domain`;
export const RDFS_LABEL_IRI = `${RDFS_IRI}label`;
export const RDFS_RANGE_IRI = `${RDFS_IRI}range`;
export const RDFS_SUBCLASS_IRI = `${RDFS_IRI}subClassOf`;

export const HTTP_SCHEMA_ORG_IRI = 'http://schema.org/';
export const HTTP_SCHEMA_ORG_DOMAIN_INCLUDES_IRI = `${HTTP_SCHEMA_ORG_IRI}domainIncludes`;
export const HTTP_SCHEMA_ORG_RANGE_INCLUDES_IRI = `${HTTP_SCHEMA_ORG_IRI}rangeIncludes`;

export const HTTPS_SCHEMA_ORG_IRI = 'https://schema.org/';
export const HTTPS_SCHEMA_ORG_DOMAIN_INCLUDES_IRI = `${HTTPS_SCHEMA_ORG_IRI}domainIncludes`;
export const HTTPS_SCHEMA_ORG_RANGE_INCLUDES_IRI = `${HTTPS_SCHEMA_ORG_IRI}rangeIncludes`;

export const GEOSPARQL_IRI = 'http://www.opengis.net/ont/geosparql#';
export const GEOSPARQL_JSON_LITERAL_IRI =
  `${GEOSPARQL_IRI}geoJSONLiteral` as const;
export const GEOSPARQL_WKT_LITERAL_IRI = `${GEOSPARQL_IRI}wktLiteral` as const;

export const XSD_IRI = 'http://www.w3.org/2001/XMLSchema#';
export const XSD_ANY_URI = `${XSD_IRI}anyURI` as const;
export const XSD_BOOLEAN_IRI = `${XSD_IRI}boolean` as const;
export const XSD_DATE_IRI = `${XSD_IRI}date` as const;
export const XSD_DATE_TIME_IRI = `${XSD_IRI}dateTime` as const;
export const XSD_DAY_TIME_DURATION_IRI = `${XSD_IRI}dayTimeDuration` as const;
export const XSD_DECIMAL_IRI = `${XSD_IRI}decimal` as const;
export const XSD_DOUBLE_IRI = `${XSD_IRI}double` as const;
export const XSD_DURATION_IRI = `${XSD_IRI}duration` as const;
export const XSD_FLOAT_IRI = `${XSD_IRI}float` as const;
export const XSD_INTEGER_IRI = `${XSD_IRI}integer` as const;
export const XSD_STRING_IRI = `${XSD_IRI}string` as const;
export const XSD_TIME_IRI = `${XSD_IRI}time` as const;
export const XSD_YEAR_MONTH_DURATION_IRI =
  `${XSD_IRI}yearMonthDuration` as const;

export const STARDOG_API_IRI = 'tag:stardog:api:';

export const STARDOG_CONTEXT_IRI = `${STARDOG_API_IRI}context:`;
export const STARDOG_CONTEXT_ALL_IRI = `${STARDOG_CONTEXT_IRI}all`;
export const STARDOG_CONTEXT_DEFAULT_IRI = `${STARDOG_CONTEXT_IRI}default`;
export const STARDOG_CONTEXT_LOCAL_IRI = `${STARDOG_CONTEXT_IRI}local`;
export const STARDOG_CONTEXT_NAMED_IRI = `${STARDOG_CONTEXT_IRI}named`;
export const STARDOG_CONTEXT_VIRTUAL_IRI = `${STARDOG_CONTEXT_IRI}virtual`;

export const STARDOG_DATA_CATALOG_IRI = `${STARDOG_API_IRI}catalog:`;
export const STARDOG_DATA_CATALOG_DATA_SOURCE_IRI = `${STARDOG_DATA_CATALOG_IRI}DataSource`;
export const STARDOG_DATA_CATALOG_DATABASE_CATALOG_IRI = `${STARDOG_DATA_CATALOG_IRI}DatabaseCatalog`;
export const STARDOG_DATA_CATALOG_COLUMN_IRI = `${STARDOG_DATA_CATALOG_IRI}Column`;
export const STARDOG_DATA_CATALOG_DATABASE_SCHEMA_IRI = `${STARDOG_DATA_CATALOG_IRI}DatabaseSchema`;
export const STARDOG_DATA_CATALOG_TABLE_IRI = `${STARDOG_DATA_CATALOG_IRI}Table`;
export const STARDOG_DATA_CATALOG_COLUMN_TYPE_IRI = `${STARDOG_DATA_CATALOG_IRI}columnType`;
export const STARDOG_DATA_CATALOG_HAS_CATALOG_IRI = `${STARDOG_DATA_CATALOG_IRI}hasCatalog`;
export const STARDOG_DATA_CATALOG_HAS_COLUMN_IRI = `${STARDOG_DATA_CATALOG_IRI}hasColumn`;
export const STARDOG_DATA_CATALOG_HAS_SCHEMA_IRI = `${STARDOG_DATA_CATALOG_IRI}hasSchema`;
export const STARDOG_DATA_CATALOG_HAS_TABLE_IRI = `${STARDOG_DATA_CATALOG_IRI}hasTable`;

export const STARDOG_GRAPH_IRI = `${STARDOG_API_IRI}graph:`;
export const STARDOG_GRAPH_ALIAS_IRI = `${STARDOG_GRAPH_IRI}alias`;
export const STARDOG_GRAPH_ALIASES_IRI = `${STARDOG_GRAPH_IRI}aliases`;

export const STARDOG_LABEL_IRI = `${STARDOG_API_IRI}label`;

export const STARDOG_SQL_IRI = `${STARDOG_API_IRI}sql:`;
export const STARDOG_SQL_SCHEMA_IRI = `${STARDOG_SQL_IRI}schema`;

export const STARDOG_PROPERTY_IRI = `${STARDOG_API_IRI}property:`;
export const STARDOG_PROPERTY_TEXT_MATCH_IRI = `${STARDOG_PROPERTY_IRI}textMatch`;
